import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function ACurbaniaonrrentinakurdi() {



    const cardData =
    {
        keyword: 'AC Urbania on Rent in Akurdi Pune',
        heading: 'Urbania on rent in pune: AC Urbania on Rent in Akurdi Pune',
        headingDescription: 'Urbania On Rent in Pune offers premium and reliable AC Urbania on Rent in Akurdi Pune for corporate groups, families, tourists, and event travelers in the area. Our well-maintained Force Urbania AC fleet provides spacious seating, powerful air-conditioning, and smooth performance, making it ideal for airport transfers, corporate travel, weddings, sightseeing, and outstation journeys from Akurdi. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from Akurdi, Nigdi, Pimpri Chinchwad, Ravet, Dighi, and Pune Airport, we ensure a cool, comfortable, and stress-free travel experience. Backed by 24/7 booking support, punctual service, and competitive pricing, Urbania On Rent in Pune stands out as the trusted choice for AC Urbania hire in Akurdi Pune.',

        top: 'Top Places to Visit in Pune with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic historical fort and a powerful symbol of Maratha pride. Once the administrative center of Bajirao I, it features massive stone walls, majestic gates like the Delhi Darwaza, and spacious courtyards. Although a major fire destroyed much of the structure, the remaining fort reflects royal grandeur. The evening light-and-sound show narrates Maratha history, making it a must-visit heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is one of Pune’s most important landmarks connected to India’s freedom struggle. Built in 1892, it served as a prison for Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai during the Quit India Movement. The palace now houses a museum displaying Gandhi’s personal belongings, photographs, and letters. Its Italian-style arches, lush lawns, and peaceful environment make it both historically significant and visually stunning."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most famous and revered Ganesh temple. The idol is richly adorned with gold ornaments and attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the heart of Pune’s grand celebrations with processions and cultural programs. The temple trust is also well known for its social and charitable initiatives, making it spiritually and socially significant."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a historic hill fortress located amidst the Sahyadri ranges and is famous for the legendary battle fought by Tanaji Malusare. The fort offers panoramic views of Pune city, ancient bastions, memorials, and scenic trekking routes. Visitors enjoy traditional Maharashtrian food like pithla-bhakri at the top. It is a perfect destination combining history, adventure, and natural beauty."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut temple dedicated to Lord Shiva, carved from a single basalt rock. It features monolithic pillars, a circular Nandi mandap, and ancient carvings reflecting early Indian craftsmanship. Despite being located in a busy area, the temple maintains a calm and spiritual ambiance, offering a peaceful retreat within the city."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected from across India, showcasing traditional art, musical instruments, sculptures, and household items. One of its highlights is the recreated Mastani Mahal. The museum offers deep insight into India’s cultural heritage and is a treasure trove for history lovers, students, and art enthusiasts."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks and offers breathtaking panoramic views after climbing 103 stone steps. The hilltop Parvati Temple, built during the Peshwa era, is dedicated to Lord Shiva and Goddess Parvati. The complex also includes smaller shrines and a museum. Sunrise and sunset views from the hill are especially captivating."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a globally renowned center for meditation, mindfulness, and wellness. Surrounded by lush gardens, it attracts visitors from around the world seeking peace, relaxation, and self-discovery. The serene atmosphere and unique meditation techniques make it a distinctive spiritual destination in Pune."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped garden. It features flowing water streams, stone bridges, manicured lawns, and seasonal flowers. The garden offers a peaceful environment for walks, photography, and family outings, beautifully blending Japanese aesthetics with Indian natural beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular picnic and leisure spot near Pune. The expansive water body, surrounding hills, and cool breezes create a scenic setting, especially during monsoon and evenings. Local vendors selling corn and tea add to its charm. It also serves as the gateway to Sinhagad Fort, making it a favorite weekend getaway."
  }
],



"services": [
    {
      "name": "AC Urbania on Rent in Akurdi Pune",
      "description": "AC Urbania on Rent in Akurdi Pune offers comfortable and reliable air-conditioned Urbania vehicles for local, corporate, and group travel. With spacious seating, clean interiors, and professional chauffeurs, this service ensures a smooth, safe, and pleasant travel experience for families, offices, and social events."
    },
    {
      "name": "Akurdi Urbania AC Bus Hire",
      "description": "Akurdi Urbania AC Bus Hire provides fully air-conditioned buses suitable for group transportation, corporate outings, and family trips. The service focuses on punctuality, comfort, and safety, making it ideal for both short city rides and longer journeys."
    },
    {
      "name": "Urbania Rental Service Akurdi Pune",
      "description": "Urbania Rental Service Akurdi Pune delivers dependable Urbania rental solutions tailored for local and outstation travel needs. Vehicles are well-maintained, spacious, and chauffeur-driven, ensuring passengers enjoy a comfortable and hassle-free journey every time."
    },
    {
      "name": "Urbania AC Bus on Rent Akurdi",
      "description": "Urbania AC Bus on Rent Akurdi offers climate-controlled buses designed for comfortable group travel. Ideal for corporate events, weddings, and tours, this service ensures smooth rides, ample space, and professional driver support."
    },
    {
      "name": "Corporate Urbania Hire Akurdi",
      "description": "Corporate Urbania Hire Akurdi provides professional transportation solutions for offices, IT companies, and business clients. With punctual service, executive comfort, and trained chauffeurs, it is perfect for meetings, conferences, and employee transportation."
    },
    {
      "name": "Urbania for Outstation Akurdi Pune",
      "description": "Urbania for Outstation Akurdi Pune ensures safe and comfortable long-distance travel with highway-experienced chauffeurs. Ideal for family tours, pilgrimages, and corporate travel, the service focuses on reliability, comfort, and timely travel."
    },
    {
      "name": "Urbania Airport Transfer Akurdi",
      "description": "Urbania Airport Transfer Akurdi provides timely pickup and drop services to and from Pune Airport. With air-conditioned vehicles, ample luggage space, and professional drivers, passengers can enjoy stress-free airport transfers."
    },
    {
      "name": "Luxury AC Urbania Akurdi",
      "description": "Luxury AC Urbania Akurdi offers premium Urbania vehicles featuring plush interiors and superior comfort. Ideal for VIP travel, weddings, and executive transportation, this service delivers a stylish and smooth travel experience."
    },
    {
      "name": "Affordable AC Urbania Hire Akurdi",
      "description": "Affordable AC Urbania Hire Akurdi provides cost-effective rental options without compromising on comfort or service quality. Suitable for families, groups, and office travel, it ensures reliable vehicles and transparent pricing."
    },
    {
      "name": "Chauffeur Driven AC Urbania Akurdi",
      "description": "Chauffeur Driven AC Urbania Akurdi ensures stress-free travel with trained and background-verified drivers. Vehicles are clean, spacious, and well-maintained, allowing passengers to relax and enjoy a comfortable journey."
    },
    {
      "name": "Urbania for Wedding Events Akurdi",
      "description": "Urbania for Wedding Events Akurdi provides elegant and organized transportation for wedding guests and family members. With air-conditioned comfort, professional chauffeurs, and punctual service, it helps manage wedding travel smoothly."
    },
    {
      "name": "Urbania for Office Trips Akurdi",
      "description": "Urbania for Office Trips Akurdi delivers dependable transportation for daily office commutes, team outings, and corporate events. With a focus on punctuality and comfort, it ensures smooth and professional travel for employees."
    },
    {
      "name": "Best AC Urbania Rental Akurdi Pune",
      "description": "Best AC Urbania Rental Akurdi Pune offers top-rated Urbania rental services known for vehicle quality, reliable service, and customer satisfaction. Ideal for all travel needs, it guarantees a safe and comfortable experience."
    },
    {
      "name": "Urbania Group Travel Akurdi",
      "description": "Urbania Group Travel Akurdi specializes in transporting groups comfortably and efficiently. Whether for tours, corporate outings, or social events, this service provides spacious vehicles and professional chauffeurs for seamless group travel."
    },
    {
      "name": "Reliable Urbania Hire Akurdi Pune",
      "description": "Reliable Urbania Hire Akurdi Pune focuses on safety, punctuality, and customer satisfaction. With well-maintained vehicles and experienced drivers, it offers dependable transportation solutions for local, outstation, and event travel."
    }
  ],
  "tableData": [
    ["AC Urbania on Rent in Akurdi Pune", "Akurdi Urbania AC Bus Hire"],
    ["Urbania Rental Service Akurdi Pune", "Urbania AC Bus on Rent Akurdi"],
    ["Corporate Urbania Hire Akurdi", "Urbania for Outstation Akurdi Pune"],
    ["Urbania Airport Transfer Akurdi", "Luxury AC Urbania Akurdi"],
    ["Affordable AC Urbania Hire Akurdi", "Chauffeur Driven AC Urbania Akurdi"],
    ["Urbania for Wedding Events Akurdi", "Urbania for Office Trips Akurdi"],
    ["Best AC Urbania Rental Akurdi Pune", "Urbania Group Travel Akurdi"],
    ["Reliable Urbania Hire Akurdi Pune", ""]
  ],



"whychoose": [
    {
        "WhyChooseheading": "Comfortable AC Urbania on Rent in Akurdi Pune",
        "WhyChoosedescription": "AC Urbania on Rent in Akurdi Pune is perfect for travelers looking for a cool, comfortable, and spacious ride for family trips, corporate travel, and outstation journeys."
    },
    {
        "WhyChooseheading": "Premium and Well-Maintained AC Force Urbania Vehicles",
        "WhyChoosedescription": "AC Urbania on Rent in Akurdi Pune offers premium Force Urbania vehicles with efficient air-conditioning, modern interiors, and ample seating space for a smooth travel experience."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "AC Urbania on Rent in Akurdi Pune comes with trained drivers who are familiar with local city routes, highways, and outstation destinations, ensuring safe and timely travel."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "Choose AC Urbania on Rent in Akurdi Pune for competitive rental rates with no hidden charges, making your travel reliable and budget-friendly."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "AC Urbania on Rent in Akurdi Pune provides round-the-clock assistance for bookings, inquiries, and last-minute travel needs."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "AC Urbania on Rent in Akurdi Pune is available for hourly rentals, full-day bookings, corporate travel, wedding transportation, and customized outstation packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All AC Urbania vehicles on rent in Akurdi Pune are regularly cleaned, sanitized, and serviced to ensure a safe and comfortable journey."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "AC Urbania on Rent in Akurdi Pune guarantees timely pickups and dependable service for stress-free group travel."
    }
]
}

const faqData = [
    {
        question: 'Is AC Urbania on Rent in Akurdi Pune available for both local and outstation travel?',
        answer: 'Yes, AC Urbania on Rent in Akurdi Pune can be booked for local city travel, sightseeing, and outstation journeys.',
    },
    {
        question: 'How can I book AC Urbania on Rent in Akurdi Pune?',
        answer: 'You can book AC Urbania on Rent in Akurdi Pune via phone, WhatsApp, or online booking for quick and hassle-free reservations.',
    },
    {
        question: 'Why choose AC Urbania on Rent in Akurdi Pune for group travel?',
        answer: 'AC Urbania on Rent in Akurdi Pune offers spacious seating, efficient air-conditioning, and comfort, making it ideal for families, corporate groups, and long trips.',
    },
    {
        question: 'Is AC Urbania on Rent in Akurdi Pune suitable for corporate and event travel?',
        answer: 'Yes, AC Urbania on Rent in Akurdi Pune is perfect for corporate trips, airport transfers, weddings, events, and business meetings.',
    },
    {
        question: 'Are drivers experienced with AC Urbania on Rent in Akurdi Pune?',
        answer: 'Yes, all drivers are professionally trained, licensed, and experienced in handling AC Urbania vehicles to ensure safety and comfort.',
    },
    {
        question: 'Can I customize pickup and drop-off locations?',
        answer: 'Absolutely. AC Urbania on Rent in Akurdi Pune allows flexible pickup and drop-off locations across Akurdi, Pune, and nearby areas.',
    },
    {
        question: 'Is AC Urbania on Rent in Akurdi Pune available 24x7?',
        answer: 'Yes, AC Urbania on Rent in Akurdi Pune operates 24x7 to meet your travel needs at any time.',
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all AC Urbania vehicles are regularly cleaned, sanitized, and maintained with strict safety protocols.',
    },
    {
        question: 'What payment options are available?',
        answer: 'AC Urbania on Rent in Akurdi Pune accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey to ensure a smooth and stress-free experience.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Sachin Bhosale',
        feedback: 'We booked AC Urbania on Rent in Akurdi Pune for an outstation trip. The vehicle was cool, comfortable, and perfect for long-distance travel.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Priya More',
        feedback: 'AC Urbania on Rent in Akurdi Pune provided excellent service for our corporate event. The driver was professional and punctual.',
        rating: 5,
    },
];









































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "AC Urbania on Rent in Akurdi Pune",
  "image": "https://urbaniaonrentpune.in/assets/images/ac-urbania-akurdi-pune.jpg",
  "description": "AC Urbania on Rent in Akurdi Pune offers luxury AC Urbania buses for corporate trips, outstation travel, airport transfers, weddings, office trips, and group travel. Chauffeur-driven buses ensure safe, comfortable, and convenient transportation in Akurdi and surrounding areas.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/ac-urbania-on-rent-akurdi-pune"
  }
};




    return (
        <div>

<Helmet>
  <title>
    Call:+91 9209423113 | AC Urbania on Rent in Akurdi Pune | Luxury & Chauffeur Driven Urbania Hire 
  </title>

  <meta
    name="description"
    content="Book AC Urbania on Rent in Akurdi Pune for corporate trips, outstation travel, airport transfers, weddings, office trips, and group travel. Luxury AC Urbania buses with chauffeur-driven service ensure safe, comfortable, and convenient transportation in Akurdi Pune."
  />

  <meta
    name="keywords"
    content="AC Urbania on Rent in Akurdi Pune, Akurdi Urbania AC Bus Hire, Urbania Rental Service Akurdi Pune, Urbania AC Bus on Rent Akurdi, Corporate Urbania Hire Akurdi, Urbania for Outstation Akurdi Pune, Urbania Airport Transfer Akurdi, Luxury AC Urbania Akurdi, Affordable AC Urbania Hire Akurdi, Chauffeur Driven AC Urbania Akurdi, Urbania for Wedding Events Akurdi, Urbania for Office Trips Akurdi, Best AC Urbania Rental Akurdi Pune, Urbania Group Travel Akurdi, Reliable Urbania Hire Akurdi Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/52.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default ACurbaniaonrrentinakurdi;